import React from "react";
import "./styles/App.css";
import NavBar from "./NavBars/NavBar";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./Pages/Home";
import SinglePage from "./Pages/SingleProduct";
import Checkout from "./components/Payments/Checkout";
import Footer from "./Pages/Footer";
import Login from "./Pages/Login_register";
import PizzaLoading from "./strapi/loading-gifs/Pizza-loading";
import Alert from "./strapi/loading-gifs/Alert";
import { ExtraContext } from "./context/ExtraFunctions";
import { CartServerSide } from "./context/api_response";
import { DishesContext } from "./context/dishes";
import { UserContext } from './context/user';
import About from "./Pages/About";
import Complete from "./Pages/Complete";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import GoogleAuth from "./strapi/third_party_auth/GoogleAuth";
import Orders from './Pages/Orders';
import SideBar from "./NavBars/Sidebar";
import Deadend from "./Pages/Error";
import Cart from "./Pages/Cart";
import TestGif from "./strapi/loading-gifs/Pizza-loading";

const  App = () => {
  const { alert, gif, get_delivery,
    delivery, } = React.useContext(ExtraContext);
  const { orders, cart, total } = React.useContext(CartServerSide);
  const { phone_screen } = React.useContext(DishesContext);
  const {loading} = React.useContext(UserContext);

  return (
    <div className="content">
      <Router>
        {phone_screen ? <SideBar /> : <NavBar />}
        <div className='position-relative'>
         {alert.show && <Alert type={alert.type} text={alert.text} />}
        </div>
        { gif && <PizzaLoading /> }
        <Switch>
          <Route exact path="/pizza-product">
            <SinglePage />
          </Route>

          <Route exact path="/">
            <Home />
          </Route>

          <Route path="/user-orders">
            {orders.length === 0 ? <Home /> : <Orders orders={orders} phone_screen={phone_screen} />}
          </Route>

          <PublicRoute restricted={true} path="/login">
            <Login />
          </PublicRoute>

          <Route path="/notfound">
            <Deadend />
          </Route>

          <Route path="/random">
            <TestGif />
          </Route>

          <Route path="/googleauth">
            <GoogleAuth />
          </Route>

          <PrivateRoute path="/complete">
            <Complete />
          </PrivateRoute>

          <Route path="/about">
            <About />
          </Route>

          <PublicRoute restricted={false} path="/cart-page">
            <Cart cart={cart} loading={loading} get_delivery={get_delivery} delivery={delivery} total={total} />
          </PublicRoute>

          <PrivateRoute path="/pizza-product/:title/:category/:id">
            <SinglePage />
          </PrivateRoute>

          <PrivateRoute path="/checkout">
            <Checkout />
          </PrivateRoute>

          <Route>
            <Deadend />
          </Route>

          
        </Switch>
        <footer>
          <Footer />
        </footer>
      </Router>
    </div>
  );
}

export { App as default };
